import React from "react";
import "./TagContainer.css";

export default ({ children }) => {
  return <div className="TagContainer">{children}</div>;
};
